export default function Integer() {}

// https://stackoverflow.com/questions/14636536/how-to-check-if-a-variable-is-an-integer-in-javascript
export function isInteger(value) {
  if (isNaN(value)) {
    return false;
  }
  var x = parseFloat(value);
  return (x | 0) === x;
}
//# sourceMappingURL=Integer.js.map


//////////////////
// WEBPACK FOOTER
// ./~/read-excel-file/modules/types/Integer.js
// module id = 878
// module chunks = 1